/**
 * KAN-944: виден ли клиент текущему пользователю и кто из менеджеров его взял.
 * GET /api/v1/clients/{id}/access/:
 *   200 {visible: true, taken_by: null} - свой клиент или без менеджера;
 *   200 {visible: false, taken_by: {name}} - клиента взял другой менеджер;
 *   404 - клиента нет или он чужой организации.
 */
import { apiClient } from './client';

export interface ClientAccess {
  visible: boolean;
  taken_by: { name: string } | null;
}

export function clientAccessUrl(clientId: string): string {
  return `/api/v1/clients/${clientId}/access/`;
}

export const clientAccessApi = {
  get: async (clientId: string): Promise<ClientAccess> =>
    (await apiClient.get<ClientAccess>(clientAccessUrl(clientId))).data,
};
